// ##############################
// // // Tasks for TasksCard - see Dashboard view
// #############################

var bugs = [
  "Trục đất: Yêu cầu đất nhuyễn, Rơm rạ vùi lấp, độ lún bùn 25-30cm",
  "Ngâm ủ giống: Ngâm 24h, ủ 24h, yêu cầu độ đài mầm 5cm",
  "San phẳng: Yêu cầu mặt ruộng không còn gồ ghề",
  "Khơi nước: Yêu cầu mặt đất hết nước và khô ráo",
];
var website = [
  "Bón lót: Trộn đều phân và rải đều khắp mặt ruộng trước khi cấy",
  "Rải giống: Mật độ 15kg/1000",
  "Phun cỏ mầm: Mật độ 0,5l/ha",
  "Bơm xả nước: Ngập mặn 0,4cm",
];
var server = [
  "Thăm ruộng đồng ngày 1,2,3: Tỉ lệ nảy mầm (30 mầm/m2)",
  "Thăm ruộng đồng ngày 4,5,6: Độ cao lúa? Số lá? Sâu bệnh?",
  "Xử lý bọ trĩ: 2 con/ 1 cây",
];

module.exports = {
  // these 3 are used to create the tasks lists in TasksCard - Dashboard view
  bugs,
  website,
  server,
};
